// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
/*RTAX
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDPHiytzuWgTBGFOcaHe4fLuGrG-nzO2Xk",
    authDomain: "rtax-ac72d.firebaseapp.com",
    databaseURL: "https://rtax-ac72d.firebaseio.com",
    projectId: "rtax-ac72d",
    storageBucket: "",
    messagingSenderId: "1026048696526"
  }
};
*/

//OTEX
export const environment = {
  production: false,
  firebase:  {
  apiKey: "AIzaSyBaQI1z7YCQ_0hKvABUqriN8f6-LBYKnkw",
  authDomain: "otex-bae44.firebaseapp.com",
  databaseURL: "https://otex-bae44.firebaseio.com",
  projectId: "otex-bae44",
  storageBucket: "",
  messagingSenderId: "539000852039"
}
};
